/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyOneDriveIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-onedrive" */ './utils').then((m) => m.OneDriveIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/onedrive/icon' },
);

const LazyOneDriveSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-onedrive-search-result" */ './utils').then(
			(m) => m.OneDriveSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/onedrive/search-result-icon' },
);

const LazyOneDriveIconBorderlessComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-onedrive-borderless" */ './utils').then(
			(m) => m.OneDriveIconBorderless,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/onedrive/icon-borderless' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const OneDriveIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyOneDriveIconComponent />
	</Suspense>
);

export const OneDriveSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyOneDriveSearchResultIconComponent />
	</Suspense>
);

export const OneDriveIconBorderless = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyOneDriveIconBorderlessComponent />
	</Suspense>
);
